package com.trevorwiebe.timesheet.loads.domain.usecases

import com.trevorwiebe.timesheet.admin.customer.domain.CustomerRepository
import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.core.domain.model.Customer
import com.trevorwiebe.timesheet.loads.domain.LoadsRepository
import com.trevorwiebe.timesheet.loads.domain.model.Load
import com.trevorwiebe.timesheet.loads.domain.model.LoadStop
import com.trevorwiebe.timesheet.mileage.domain.LocationRepository
import com.trevorwiebe.timesheet.mileage.domain.model.Location

data class LoadStopDraft(
    val stop: LoadStop,
    val newLocation: Location?,
)

class AddLoad(
    private val loadsRepository: LoadsRepository,
    private val locationRepository: LocationRepository,
    private val customerRepository: CustomerRepository,
) {
    suspend fun invoke(
        load: Load,
        stopDrafts: List<LoadStopDraft>,
        newCustomer: Customer?,
    ): TSResult {
        var customerId = load.customerId
        if (newCustomer != null) {
            val result = customerRepository.addCustomer(newCustomer)
            if (!result.error.isNullOrEmpty()) return result
            customerId = result.data as String
        }

        val finalStops = mutableListOf<LoadStop>()
        for (draft in stopDrafts) {
            var locationId = draft.stop.locationId
            if (draft.newLocation != null) {
                val result = locationRepository.addLocation(draft.newLocation)
                if (!result.error.isNullOrEmpty()) return result
                locationId = result.data as String
            }
            finalStops.add(draft.stop.copy(locationId = locationId))
        }

        return loadsRepository.addLoad(
            load.copy(
                customerId = customerId,
                stops = finalStops,
            )
        )
    }
}
